import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=7970d0d9&scoped=true&"
import script from "./Btn.vue?vue&type=script&lang=ts&"
export * from "./Btn.vue?vue&type=script&lang=ts&"
import style0 from "./Btn.vue?vue&type=style&index=0&id=7970d0d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7970d0d9",
  null
  
)

export default component.exports